module.exports = __webpack_public_path__ + "static/img/block2_3.98ec7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block2_3.png
// module id = Cfn3
// module chunks = 1